import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import AccountCircle from '@material-ui/icons/PermContactCalendar';

import { BlueRightArrowIcon } from '../../../../images/icons/WrapSvg';

class Provider extends React.Component {
    handleClick = (event) => {
        this.props.history.push('/manage/providers/' + this.props.provider.id);
    };

    render() {
        const { provider, active, last } = this.props;
        const nombre = provider.nombre.toUpperCase().trim();
        return (
            <div
                className={
                    'flex_full_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand ' +
                    (active ? 'active' : '')
                }
                onClick={this.handleClick}
            >
                <AccountCircle className={'c_bluish margin_right_12'} />
                <div
                    className={classNames(
                        'flex_full_row align_center',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <div className={'flex_full_row '}>
                        <span className="barlow_medium c_dark_grey_blue">{nombre}</span>
                    </div>
                    <BlueRightArrowIcon color="primary" />
                </div>
            </div>
        );
    }
}

Provider.propTypes = {
    history: PropTypes.object.isRequired,
};

export default withRouter(Provider);



// WEBPACK FOOTER //
// ./src/components/complex/manage/providers/Provider.js